import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bordered-card-header" }
const _hoisted_2 = { class: "d-flex gap-2" }
const _hoisted_3 = { class: "action-buttons" }
const _hoisted_4 = { class: "card-wrapper" }
const _hoisted_5 = { class: "bordered-card table-card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bordered-card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, " Allocations for Beneficiary(ies) ")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "plan-content sm-mb-40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BeneficiaryCard = _resolveComponent("BeneficiaryCard")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bordered-card bordered-card-beneficiary", { 'has-changes': _ctx.beneficiary?.Additional?.PendingDeletion }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.beneficiary?.Name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: "iatse-icon-edit plan-modal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.beneficiary?.Additional?.PendingDeletion && _ctx.handleEditBene(_ctx.beneficiary)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BeneficiaryCard, {
        mode: "single",
        title: _ctx.beneficiary.Name,
        data: _ctx.beneficiary.General,
        beneficiary: _ctx.beneficiary,
        actionButtons: true,
        customClass: "single-card"
      }, null, 8, ["title", "data", "beneficiary"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_ctx.beneficiary.Allocations)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_DataTable, {
              table: _ctx.beneficiary.Allocations,
              classes: {
          'striped small': true
        }
            }, null, 8, ["table"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}